import React from 'react'
import { FormikInput } from 'components'
import { useStyles } from '../styles'
import { formatDecimal } from 'utils/getters/common'
import { useSelector } from 'react-redux'

const ExpenseFormBody = ({ values, setFieldValue, isAccountant }) => {
  const classes = useStyles()
  const currentUser = useSelector(state => state.auth.currentUser)
  const contactInfo = useSelector(state => state.profileCreation.profileData.contactInfo)
  const userCountry = contactInfo?.country || currentUser?.country || 840 // Default to USA

  const getCurrencySymbol = () => {
    return userCountry === 124 ? 'C$' : '$' // 124 is Canada, 840 is USA
  }
  const { editMode } = values
  return (
    <div className={classes.container}>
      <div className={classes.row}>
        <FormikInput
          variant="outlined"
          size="small"
          name="expense"
          label={isAccountant ? `Charge Amount, ${getCurrencySymbol()}` : `Expense amount, ${getCurrencySymbol()}`}
          placeholder="0.00"
          type="text"
          fullWidth
          disabled={!editMode}
          handleBlur={e => setFieldValue('expense', formatDecimal(e.target.value))}
          inputProps={{ style: { textAlign: 'right' } }}
          containerClasses={classes.autocompleteContainer}
        />
      </div>
      {/*will be used in future*/}
      {/*<div className={classes.switchRow}>*/}
      {/*  <Switch*/}
      {/*    color="default"*/}
      {/*    formControlClasses={{ root: classes.formControlClasses }}*/}
      {/*    labelClasses={{ root: classes.checkboxLabel }}*/}
      {/*    disabled={(!values.case.expense_invoicing && values.case.fee_type !== 3) || !values.editMode}*/}
      {/*    label="Billable"*/}
      {/*    checked={values.billable}*/}
      {/*    onChange={e => setFieldValue('billable', e.target.checked)}*/}
      {/*  />*/}
      {/*  <Tooltip*/}
      {/*    title={<BillableTooltipContent billable={values.billable} tooltipText={classes.tooltipText} />}*/}
      {/*    tooltipClass={classes.tooltip}*/}
      {/*    interactive*/}
      {/*  >*/}
      {/*    <Icon style={classes.tooltipIcon} iconClass="las la-question-circle" />*/}
      {/*  </Tooltip>*/}
      {/*  {values.billable && values.case.fee_type === 3 && (*/}
      {/*    <Switch*/}
      {/*      color="default"*/}
      {/*      labelClasses={{ root: classes.checkboxLabel }}*/}
      {/*      label="Charge"*/}
      {/*      disabled={!values.editMode}*/}
      {/*      checked={values.charge}*/}
      {/*      onChange={e => setFieldValue('charge', e.target.checked)}*/}
      {/*    />*/}
      {/*  )}*/}
      {/*</div>*/}
    </div>
  )
}

export default ExpenseFormBody
